export default "__VITE_ASSET__Cjv03JFo__"